<div [formGroup]="formGroup" class="schedule-row">
  <mat-form-field>
    <mat-label>{{ startLabel }}</mat-label>
    <input matInput type="time" step="60" formControlName="startTime" />
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ endLabel }}</mat-label>
    <input matInput type="time" step="60" formControlName="endTime" />
  </mat-form-field>
</div>
<div>
  @if (formGroup.hasError('endBeforeStart')) {
    <mat-error>L'heure de fin doit être après l'heure de début</mat-error>
  }
  @if (formGroup.hasError('required')) {
    <mat-error>Les champs de début et de fin doivent être remplis ensemble</mat-error>
  }
</div>
